import { withInstall } from '@tav-ui/utils/with-install'
import BasicArrow from './src/basic-arrow.vue'
const TaBasicArrow = withInstall(BasicArrow)
export { TaBasicArrow }
export default TaBasicArrow
export * from './src/types'
